import type { Client, FirmSettings } from '@/types';
import { projectAssemblyReadiness, type AssemblyVersion } from '../../functions/src/modules/hipaa/hipaaAssembly.shared';

export function authorizationSetupState(settings: Partial<FirmSettings> = {}): 'ready' | 'activation-required' | 'setup-required' {
  if (settings.hipaaDocumentWorkflow === 'assemble') return settings.hipaaAssemblyVersionId ? 'ready' : 'setup-required';
  if (settings.hipaaTemplateType === 'general' || (settings.hipaaTemplateConfirmedAt && Object.keys(settings.hipaaTemplateFieldMappings ?? {}).length)) return 'ready';
  return settings.hipaaAssemblyVersionId ? 'activation-required' : 'setup-required';
}

export function assemblyClientReadiness(client: Client, version: Pick<AssemblyVersion, 'lifecycle'> | undefined, facilityComplete: boolean) {
  const association = client.hipaaAssemblyAssociation;
  const source = association ?? client.hipaaSourceCandidate;
  return projectAssemblyReadiness({ activated: true, hasVersion: !!version, version, hasSource: !!source || !!client.hipaaAuthorizationStoragePath,
    signatureVerified: !!source?.signatureReceiptId, associationConfirmed: !!association && association.revision === client.hipaaAssociationRevision,
    facilityComplete });
}
